import { atom } from 'recoil';

import { ResourceStatus } from '@/features/polling/hooks/usePolling';

export const prevResourceStatusDataState = atom<ResourceStatus[]>({
  key: 'prevResourceStatusData',
  default: [],
});
